import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import DraftUserCard from '../DraftUserCard';

const DraftUserCards = ({ users, draft, loading }) => {
  const userIds = Object.keys(users);

  if (loading) {
    return (
      <div className="text-center">
        <FontAwesomeIcon icon={faSpinner} size="3x" spin className="text-yellow" />
      </div>
    );
  }

  if (userIds.length === 0) {
    return <p className="mb-0 text-mute">None</p>;
  }

  return userIds.map((userId) => draft[userId] && (
    <DraftUserCard
      key={userId}
      userId={userId}
      user={users[userId]}
      draftEntry={draft[userId]}
    />
  ));
};

DraftUserCards.propTypes = {
  users: PropTypes.objectOf(PropTypes.shape({
    displayName: PropTypes.string,
    email: PropTypes.string,
    lastLogin: PropTypes.string,
  })).isRequired,
  draft: PropTypes.objectOf(PropTypes.shape({
    teamName: PropTypes.string,
    draftInPerson: PropTypes.bool,
    logoUrl: PropTypes.string,
    logoUpload: PropTypes.bool,
    logoUploadFilename: PropTypes.string,
    songList: PropTypes.arrayOf(PropTypes.shape({
      songTitle: PropTypes.string,
      songUrl: PropTypes.string,
    })),
  })).isRequired,
  loading: PropTypes.bool.isRequired,
};

export default DraftUserCards;
